import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-up-bold--sprite",
  "use": "arrow-up-bold--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"arrow-up-bold--sprite\"><path d=\"M15,20H9V12H4.16L12,4.16L19.84,12H15V20Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol